export enum StreamStatus {
  LIVE = 1,
  RECORDED = 2,
}

export enum StreamMethod {
  EXTERNAL_CAMERA = 0,
  HOST_APP = 1,
}

export enum StreamProviderStatus {
  CREATED = 0,
  STARTED = 1,
  ENDED = 2,
  ADMIN_ENDED = 3,
  WAITING_TO_START = 4,
  READY_TO_START = 5,
}

export enum ScreenType {
  PORTRAIT = 0,
  LANDSCAPE = 1,
}

export enum StreamProvider {
  IVS = 0,
  TENCENT = 1,
}

export const INTERVAL_STATISTIC = 30000

export const MAX_STREAM_TITLE_LENGTH = 225

export enum StreamViewCountType {
  ACCUMULATIVE = 0,
  CONCURRENT = 1,
}
